export default "__VITE_ASSET__Bgn1QkvP__"